import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import KYCPageUI from './KYCPageUI.js'

class KYCPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      copyToClipboardText: null,
    }
  }

  render() {
    return (
      <KYCPageUI
        context={this.props.context}
        account={this.state.account}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    if (noBusy === 'noBusy') {
      this.getAccounts(context)
    }
    else
      this.setState({ account: null }, () => {
        this.getAccounts(context)
      })
  }
}

export default withRouter(KYCPageSF)
